import {connect} from "react-redux";
import {graphql} from "react-apollo";
import AccountPage from "./AccountPage";
import * as AccountApiActions from "../actions/AccountApiActions";
import * as ViewActions from "../actions/ViewActions";
import {GET_ACCOUNT} from "../queries/customers";
import {withRouter} from "react-router";

function mapStateToProps(state, ownProps) {
  return {
    accountId: ownProps.router.params.accountId
  }
}

// VIP status is held on the customer, so the account page resolves its holder.
const withQuery = graphql(GET_ACCOUNT, {
  skip: (props) => !props.accountId,
  options: (props) => ({
    variables: {
      accountId: props.accountId
    }
  }),
  props: ({data}) => ({
    customerId: (data && data.accountHolder) ? data.accountHolder.customerId : "",
    vip: !!(data && data.accountHolder && data.accountHolder.vip)
  })
})

export default connect(mapStateToProps, {...ViewActions, ...AccountApiActions})(withRouter(withQuery(AccountPage)));
